import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import { TRANSITION } from '@shared/types/constants/animations';

const ChannelListSynopsisRightContainer = styled.div<{
  focused?: boolean;
}>`
  bottom: 0;
  display: flex;
  flex-direction: column;
  margin-left: ${37 * Screen.widthRatio}px;
  position: relative;
  top: ${-8 * Screen.widthRatio}px;
  transition: ${TRANSITION.CHANNEL_LIST_CONTENT};
`;

export default ChannelListSynopsisRightContainer;
